<ix-chip (click)="detailClick()" class="detail-chip" onkeypress=""
         variant="primary">{{ label }}
</ix-chip>

<ng-template #detailModal let-modal>
  <ix-modal centered="true">
    <ix-modal-header icon="list">{{ modal.data.header | translate }}
    </ix-modal-header>
    <ix-modal-content [style.margin-left]="0">
      <ix-input-group>
                <span slot="input-start">
                    <ix-icon name="search" size="16"></ix-icon>
                </span>
        <input (keyup)="onSearchChange($event)"
               class="ix-form-control"
               id="detail-modal-search-input"
               name="input"/>
      </ix-input-group>
      <div class="mt-3">
        <ix-typography class="mb-2" format="h4"
                       id="detail_comp_parts_table_header">
          {{ label }}
        </ix-typography>
        @if (filteredAttributes.length === 0) {
          <ix-empty-state layout="compact" icon="anomaly-found"
                          header="{{'general.empty' | translate}}"/>
        } @else {
          <table class="ix-table"
                 aria-describedby="detail_comp_parts_table_header">
            <tbody>
              @for (attribute of filteredAttributes; track attribute) {
                <tr>
                  <td>
                    <ix-typography>{{ attribute[0] }}</ix-typography>
                  </td>
                  <td>
                    <ix-typography>{{ attribute[1] }}</ix-typography>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </ix-modal-content>
    <ix-modal-footer>
      <ix-button (click)="modal.close('okay')" class="close-modal"
                 onkeypress=""
                 variant="primary">
        {{ 'general.close' | translate }}
      </ix-button>
    </ix-modal-footer>
  </ix-modal>
</ng-template>
